<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
var MQ = '(max-width: 992px)'

export default {
  name: 'App',
  mounted: function () {
    if (typeof window === 'undefined' || !window.matchMedia) return
    this._ebkMq = window.matchMedia(MQ)
    this._ebkSetMobileClass = this._syncMobileRootClass.bind(this)
    this._ebkSetMobileClass()
    this._ebkMq.addListener(this._ebkSetMobileClass)
  },
  beforeDestroy: function () {
    if (this._ebkMq && this._ebkSetMobileClass) {
      this._ebkMq.removeListener(this._ebkSetMobileClass)
    }
  },
  methods: {
    _syncMobileRootClass: function () {
      var el = document.getElementById('app')
      var root = document.documentElement
      if (!el || !this._ebkMq) return
      if (this._ebkMq.matches) {
        el.classList.add('ebk-mobile')
        if (root) root.classList.add('ebk-mobile-root')
      } else {
        el.classList.remove('ebk-mobile')
        if (root) root.classList.remove('ebk-mobile-root')
      }
    }
  }
}
</script>

<style>
.el-range-separator{
    width: 6%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue